<template>
  <div class="relative z-10 container-bg flex flex-col text-center items-center p-4 md:p-10 2xl:p-20 m-8 lg:m-12 2xl:m-24">
    <h1 class="mb-9 2xl:text-5xl">Re-send confirmation email</h1>

    <div
      v-if="message"
      class="mt-3 bg-red-300 border border-red-600 rounded-xl p-4 md:py-5 md:px-8 font-medium text-sm text-red-600 mb-8"
    >
      <span
        class="icon md:mr-3.5"
        v-html="icons.info"
      ></span>

      {{ message }}
    </div>

    <p class="text-sm lg:text-medium max-w-3xl text-grey-dark leading-7 mb-12">
      We will send you a new confirmation email.
    </p>

    <form @submit.prevent="onSubmit" class="text-left w-full max-w-sm">
      <form-field-input
        v-model.trim="email"
        class="mb-8"
        size="medium"
        type="email"
        field-label="E-mail Address *"
        placeholder="example@dsm.com"
        :validation-class="{invalid: $v.email.$error, valid: !$v.email.$invalid}"
        :disabled="hasToken"
        @blur="$v.email.$touch()"
      >
        <template #helper v-if="$v.email.$error">
          <span
            v-if="!$v.email.required"
            class="invalid"
          >
            Email can't be empty
          </span>

          <span
            v-if="!$v.email.email"
            class="invalid"
          >
            Email isn't valid
          </span>
        </template>
      </form-field-input>

      <button
        type="submit"
        class="btn-success w-full"
        :class="{'mb-5': !!message}"
      >
        Re-send email
      </button>
    </form>
  </div>
</template>

<script>
import FormFieldInput from '@/components/form/FormFieldInput';
import { validationMixin } from 'vuelidate';
import {required, email} from 'vuelidate/lib/validators';

export default {
  name: 'RequestVerificationEmail',

  components: {
    FormFieldInput
  },

  mixins: [validationMixin],

  validations() {
    return {
      email: {
        required,
        email
      }
    }
  },

  data: () => ({
    email: '',
    message: '',
  }),

  mounted() {
    // this.email = this.$route.query.email
  },

  methods: {
    onSubmit() {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      }

      this.message = ''

      const formData = {
        email: this.email
      }

      this.$api.post('/email/verification-notification', formData)
          .then(() => {
            this.$router.push({ name: 'thankYou' });
          })
          .catch(err => {
            this.message = (err.response && err.response.data && err.response.data.error) || '';
          });
    },
  },

  computed: {
    hasToken() {
      return !!this.token
    }
  }
};
</script>

<style scoped>

</style>
